import api from './api';
import { Role, Permission } from './permissionService';

// Re-export types for convenience
export type { Role, Permission };

export interface CreateRoleData {
  name: string;
  description?: string;
}

export interface UpdateRoleData {
  name?: string;
  description?: string;
}

export interface SyncPermissionsData {
  permission_ids: number[];
}

export const roleService = {
  getAll: async (): Promise<Role[]> => {
    const response = await api.get('/api/roles');
    return response.data.data || [];
  },

  getById: async (id: number): Promise<Role> => {
    const response = await api.get(`/api/roles/${id}`);
    return response.data.data;
  },

  create: async (data: CreateRoleData): Promise<Role> => {
    const response = await api.post('/api/roles', data);
    return response.data.data;
  },

  update: async (id: number, data: UpdateRoleData): Promise<Role> => {
    const response = await api.put(`/api/roles/${id}`, data);
    return response.data.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/roles/${id}`);
  },

  syncPermissions: async (id: number, permissionIds: number[]): Promise<Role> => {
    const response = await api.post(`/api/roles/${id}/permissions`, {
      permission_ids: permissionIds
    });
    return response.data.data;
  }
};

